import { useQuery } from '@tanstack/react-query';
import { configService, type PriceConfig } from '@/lib/api/categories';

// Default exchange rates as fallback (1 EUR = X currency)
const DEFAULT_EXCHANGE_RATES: PriceConfig[] = [
  { name: 'european_currency', price: 1 },
  { name: 'comoros_currency', price: 492 },
  { name: 'american_currency', price: 1.08 },
];

/**
 * Hook to fetch and cache exchange rates from the API
 */
export function useExchangeRates() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['exchange-rates'],
    queryFn: configService.getExchangeRates,
    staleTime: 1000 * 60 * 30, // 30 minutes - rates don't change often
    gcTime: 1000 * 60 * 60, // 1 hour cache
    retry: 2,
  });

  // Use API data if available, otherwise use defaults
  const exchangeRates = data && data.length > 0 ? data : DEFAULT_EXCHANGE_RATES;

  return {
    exchangeRates,
    isLoading,
    error,
    hasData: !!data && data.length > 0,
  };
}
